/**
 *  A tiny wrapper for the Storage object. We will use this one instead of directly
 *  using lower level object or api like LocalStorage. Good to abstract some logic
 *  for better reusability and easier migration.
 *
 *  For migration, we need to make sure the we will not change the interface of the Class.
 * */
export default class AppStorage {
    private _storage: Storage;

    constructor() {
        // Do some checking if the _storage which we are using is supported by the browser. Fallback to memory.

        if (window.localStorage) {
            this._storage = window.localStorage;
        } else if (window.sessionStorage) {
            this._storage = window.sessionStorage;
        } else {
            this._storage = new InmemoryStorage();
        }
    }

    // Value must serialisable
    setItem = (key: string, value: any) => {
        try {
            this._storage.setItem(key, JSON.stringify(value));
        } catch (_err) {
            console.log(
                `Error when setting the item with key ${key} inside AppStorage.`,
            );
        }
    };

    getItem = (key: string) => {
        try {
            return JSON.parse(this._storage.getItem(key));
        } catch (_err) {
            console.log(
                `Error when accessing the item with key ${key} inside AppStorage.`,
            );
        }
    };

    removeItem = (key: string) => {
        try {
            this._storage.getItem(key);
        } catch (_err) {
            console.log(
                `Error when removing then item with key ${key} inside AppStorage.`,
            );
        }
    };

    clear = () => {
        try {
            this._storage.clear();
        } catch (_err) {
            console.log('Error when clearing the AppStorage.');
        }
    };
}

class InmemoryStorage implements Storage {
    private _storage: Record<string, string> = {};
    length = 0;

    setItem = (key: string, value: any) => {
        if (!Object.hasOwn(this._storage, key)) {
            this.length += 1;
        }
        this._storage[key] = value;
    };

    getItem = (key: string) => {
        return this._storage[key];
    };

    key(index: number): string | null {
        return Object.keys(this._storage)[index] ?? null;
    }

    removeItem = (key: string) => {
        if (Object.hasOwn(this._storage, key)) {
            this.length -= 1;
        }
        Reflect.deleteProperty(this._storage, key);
    };

    clear = () => {
        this.length = 0;
        this._storage = {};
    };
}
